import Route from '@ember/routing/route';
import type StoreService from 'tio-employee/services/store';
import { service } from '@ember/service';

export default class PslfEmployerNonPartnerVerificationRoute extends Route {
  @service declare store: StoreService;

  async model() {
    const params = this.paramsFor('pslf-employer');
    const employerFormInfo = await this.store
      .adapterFor('pslf-form')
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      .verifyNonPartnerEmployer(params.form_document_id, params.approval);
    return {
      initialValues: employerFormInfo,
      documentId: params.form_document_id,
      approvalId: params.approval,
    };
  }
}
